module.exports = __webpack_public_path__ + "src/assets/img/dummy.9d9177ae.svg";